import { __decorate } from "tslib";
import { Route } from '../core';
import config from '@api/config';
var VoucherCodeValidate = /*@__PURE__*/ (function () {
    function VoucherCodeValidate() {
    }
    VoucherCodeValidate.post = function (response) {
        return response;
    };
    VoucherCodeValidate = __decorate([
        Route(config.VOUCHER_CODE_ENDPOINT + "validate/", true, true)
    ], VoucherCodeValidate);
    return VoucherCodeValidate;
}());
export { VoucherCodeValidate };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/voucher-code-validate.ts
// module id = null
// module chunks = 